/**
 * @fileoverview Space theme - match space and celestial emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class SchoolTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'school',
            'School',
            allLabels.school,
            { numPairs: 8, ...options }
        );
    }
}
